/**
 * Existierende Module
 */
export enum Module {
   Overview = "Overview",
   Events = "Events",
   Birthdays = "Birthdays",
   Groups = "Groups",
   Holidays = "Holidays",
   Mailings = "Mailings",
   Members = "Members",
   Payments = "Payments",
   Rental = "Rental",
   Clients = "Clients",
   Accounts = "Accounts",
   Statistics = "Statistics",
   Workshops = "Workshops",
   Settings = "Settings",
}